// extracted by mini-css-extract-plugin
module.exports = {"no-result-content":"_3DfouBl-","icon-wrapper":"_1Od9BDWL","not-found":"_2FCOWwxW","message":"_2rjiYPNO"};